/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {AccountModel} from "../../models/account-model";
import {AccountCreateExistingUserModel} from "../../models/account-create-existing-user-model";


export interface AccountExistingUserPostParams {
    body?: AccountCreateExistingUserModel,
    userGuid: string;

}

export function existingUserAccountPost(http: HttpClient, rootUrl: string, params: AccountExistingUserPostParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<AccountModel>> {
    const rb = new RequestBuilder(rootUrl, existingUserAccountPost.PATH, 'post');

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    if (params.userGuid) {
        rb.path('userGuid', params.userGuid, { 'style': 'simple' });
    }

    rb.body(params.body, 'application/json');

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<AccountModel>;
        })
    );
}

existingUserAccountPost.PATH = '/api/v1/users/{userGuid}/accounts';
